export default __webpack_public_path__ + "static/media/sack-square.f6462ea8.jpg";